/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-pack.reducer';

export const IntraOPPackDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPPackEntity = useAppSelector(state => state.intraOPPack.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPPackDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPPack.detail.title">IntraOPPack</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.id}</dd>
          <dt>
            <span id="packType">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.packType">Pack Type</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.packType}</dd>
          <dt>
            <span id="tmSize">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.tmSize">Tm Size</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.tmSize}</dd>
          <dt>
            <span id="site">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.site">Site</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.site}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.amount">Amount</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.amount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.active">Active</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.intraOPPack.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{intraOPPackEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPPack.nursingRecord">Nursing Record</Translate>
          </dt>
          <dd>{intraOPPackEntity.nursingRecord ? intraOPPackEntity.nursingRecord.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-pack" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-pack/${intraOPPackEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPPackDetail;
